$(document).ready(function(){

    $('a[href~="/products/hair-thickening-system"]').attr('aria-label','View product Feel Confident Hair System');
$('a[href~="/products/thickening-shampoo"]').attr('aria-label','View product Hair Thickening Shampoo');
$('a[href~="/products/thickening-conditioner"]').attr('aria-label','View product Hair Thickening Conditioner');
$('a[href~="/products/thickening-foam"]').attr('aria-label','View product Hair Thickening Foam');
$('a[href~="/products/thickening-scalp-serum"]').attr('aria-label','View product Hair Thickening Scalp Serum Leave-in');
$('a[href~="/products/thickening-shampoo-travel-size"]').attr('aria-label','View product Hair Thickening Shampoo Travel Size');
$('a[href~="/products/thickening-conditioner-travel-size"]').attr('aria-label','View product Hair Thickening Conditioner Travel Size');
$('a[href~="/products/feel-fuller-duo"]').attr('aria-label','View product Feel Fuller Duo');
$('img[src="https://cdn.shopify.com/s/files/1/0691/5637/2791/files/check-mark2.svg?v=1774864348"]').attr('alt', 'Yellow check mark icon');
$('button.carousel-btn.card-carousel__carousel-btn.card-carousel__carousel-btn--next').attr('aria-label', 'Next slide');

$('button.carousel-btn.card-carousel__carousel-btn.card-carousel__carousel-btn--prev').attr('aria-label', 'Previous slide');

$('img[src*="wall-street-journal-logo-feel-confident-press"]').attr('alt','The Wall Street Journal logo');
$('img[src*="allure-magazine-logo-feel-confident-press"]').attr('alt','Allure logo');
$('img[src*="esquire-magazine-logo-feel-confident-press"]').attr('alt','Esquire logo');
$('img[src*="deuxmoi-logo-feel-confident-press"]').attr('alt','Deuxmoi logo');
$('img[src*="new-york-magazine-logo-feel-confident-press"]').attr('alt','New York Magazine logo');
$('img[src*="c8e06cf2-b3e1-4295-8ecb-623bee8bedce"]').attr('alt','Unlock your mystery discount ');


$('a[href~="/products/rootdefense-power-duo"]').attr('aria-label','View product ROOTDefense Power Duo');
$('a[href~="/products/feel-fuller-travel-duo"]').attr('aria-label','View product Feel Fuller Travel Duo');
$('a[href~="/products/feel-confident-cap-1"]').attr('aria-label','View product Feel Confident Cap');
$('a[href~="/products/feel-confident-travel-case"]').attr('aria-label','View product Feel Confident Travel Case');
$('a[href~="/products/feel-confident%C2%AE-tote"]').attr('aria-label','View product Feel Confident Tote');
$('img[src="https://cdn.shopify.com/s/files/1/0691/5637/2791/files/right.png?v=1774615127"]').attr('alt', 'Check mark icon');

$('img[src="https://cdn.shopify.com/s/files/1/0691/5637/2791/files/wrong_66722f1a-ca58-472d-8b58-73354d443568.png?v=1774620117"]').attr('alt', 'Cross mark icon');
$("div table.comparison_image th.table_heading").append("<span style='display:none'>.</span>");

$('img[src="//feelconfident.com/cdn/shop/files/02.svg?v=1758796369"]').attr('alt', 'Moisture and hydration icon');
$('img[src="//feelconfident.com/cdn/shop/files/scalp-hydration-30-percent-increase-icon.svg?v=1779444483"]').attr('alt', 'Icon representing increased scalp hydration');
$("div.product__product-sale-amount-badge.product-sale-amount-badge").each(function() {
        var link = $(this);
        var linkText = link.text();
    var spanElement = $('<span>').text(linkText).addClass('bc');
        link.html(spanElement);
    });



$('img[src*="Alliance_Branded_Logo"]').attr('alt','The Alliance for Positive Change');
$('img[src*="Afya-Logo"]').attr('alt','Afya Foundation');
$('img[src*="Coalition_logo"]').attr('alt','Coalition for the Homeless');
$('img[src*="red_box_bc_logo"]').attr('alt','Bottomless Closet');

$("h5:empty").append("<span style='display:none'>.</span>");

$('img[src="//feelconfident.com/cdn/shop/files/thicker-hair-volume-icon.svg?v=1779114828"]').attr('alt', 'Icon representing thicker hair and added volume');

$('img[src="//feelconfident.com/cdn/shop/files/nourished.svg?v=1771798699"]').attr('alt', 'Icon representing nourished hair');

$('img[src="//feelconfident.com/cdn/shop/files/resilient-stronger-hair-icon.svg?v=1779114934"]').attr('alt', 'Icon representing stronger, more resilient hair');

$('img[src="//feelconfident.com/cdn/shop/files/natural-scent-leaf-icon.svg?v=1779114911"]').attr('alt', 'Icon representing a natural scent');
$('img[src="//feelconfident.com/cdn/shop/files/hair-comb.svg?v=1774859604"]').attr('alt', 'Hair comb icon');
$('img[src*="thumbnail.0000000000.jpg"]').attr('alt', 'Video preview thumbnail');
$('textarea[name="contact[Comment]"]').attr('aria-label', 'Enter your comment');

let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;
$('img[src="https://fonts.gstatic.com/s/i/productlogos/translate/v14/24px.svg"]').attr('alt', 'Google Translate icon');

   
    if ( $('#goog-gt-votingInputSrcLang').length) {

$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
    
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}
$('img[src="//feelconfident.com/cdn/shop/files/gq-magazine-logo-feel-confident-press.svg?v=1779441643&width=300"]').attr('alt', 'GQ magazine logo');

$("img[src=\"https://cdn.shopify.com/s/files/1/0691/5637/2791/files/lock-icon.jpg?v=1781614632\"]").attr("alt", "Padlock with keyhole, half gold and half green");
$("img[src=\"https://cdn.shopify.com/s/files/1/0691/5637/2791/files/return-icon.jpg?v=1781614632\"]").attr("alt", "Black refresh icon with arrow");
$("img[src=\"//feelconfident.com/cdn/shop/files/FeelConfident-5_woman.webp?v=1775723788&width=160\"]").attr("alt", "Woman holding scalp serum bottle and dropper");
$("img[src=\"//feelconfident.com/cdn/shop/files/Hair_before_using_Feel_Confident_science-backed_haircare2.webp?v=1779882737&width=160\"]").attr("alt", "Woman\'s scalp with thinning hair");
$("img[src=\"//feelconfident.com/cdn/shop/files/Hair_after_using_Feel_Confident_science-backed_haircare2.webp?v=1779882731&width=160\"]").attr("alt", "Woman\'s dark hair, back view, after using scalp serum");
$("img[src=\"//feelconfident.com/cdn/shop/files/Hair_before_using_Feel_Confident_science-backed_haircare6.webp?v=1780397095&width=160\"]").attr("alt", "Woman\'s scalp with thinning hair");
$("img[src=\"//feelconfident.com/cdn/shop/files/Hair_after_using_Feel_Confident_science-backed_haircare6.webp?v=1780397095&width=160\"]").attr("alt", "Woman\'s dark hair with thinning area on scalp");
$("img[src=\"//feelconfident.com/cdn/shop/files/Hair_before_using_Feel_Confident_science-backed_haircare3.webp?v=1780396170&width=160\"]").attr("alt", "Woman\'s scalp with thinning hair");
$("img[src=\"//feelconfident.com/cdn/shop/files/Hair_after_using_Feel_Confident_science-backed_haircare3.webp?v=1780396179&width=160\"]").attr("alt", "Woman\'s scalp with thinning hair");
$("img[src=\"//feelconfident.com/cdn/shop/files/feel-confident-clinical-study-percentage-icon5.png?v=1779798236&width=160\"]").attr("alt", "Black circle with 100% text inside");
$("img[src=\"//feelconfident.com/cdn/shop/files/feel-confident-clinical-study-percentage-icon2.png?v=1779798210&width=160\"]").attr("alt", "Black circle graph with 97% text");
$("img[src=\"//feelconfident.com/cdn/shop/files/feel-confident-clinical-study-percentage-icon3.png?v=1779798222&width=160\"]").attr("alt", "Black circle graph showing 94% result");
$("img[src=\"//feelconfident.com/cdn/shop/files/feel-confident-clinical-study-percentage-icon4.png?v=1779798229&width=160\"]").attr("alt", "Black circle graph showing 90%");

$("img[src=\"//feelconfident.com/cdn/shop/files/2-hands-feel-confident.webp?v=1777224771&width=160\"]").attr("alt", "Hands holding brown bottle with yellow text");
$("img[src=\"//feelconfident.com/cdn/shop/files/feel-confident-boxes.jpg?v=1777220482&width=160\"]").attr("alt", "Stacked boxes with \"feel confident\" and motivational text");

 $("img[src=\"//feelconfident.com/cdn/shop/files/Products_086698d6-e9c1-4243-8c40-6c18d210209f.svg?v=1775034868&amp;width=160\"]").attr("alt", "bottles");
    $("img[src=\"//feelconfident.com/cdn/shop/files/idea.svg?v=1775031587&amp;width=160\"]").attr("alt", "Idea icon");

    $("img[src=\"//feelconfident.com/cdn/shop/files/Shampoo.gif?v=1776774935&amp;width=160\"]").attr("alt", "Feel Confident shampoo Bottle");


console.log("ready");
});
